// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m6wJp","left":"styles_left__3J1rC","desktopActions":"styles_desktopActions__LQP0h","title":"styles_title__15W5Z"};